<script setup lang="ts"></script>

<template>
  <div class="card">
    <div class="card-content">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.card {
  background-color: #f5f5f7;
}

.card-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
}
</style>
